import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2455331a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2455331a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455331a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2455331a')) {
      api.createRecord('2455331a', component.options)
    } else {
      api.reload('2455331a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2455331a&scoped=true&", function () {
      api.rerender('2455331a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/worldcup/index.vue"
export default component.exports